import { ConfirmRegistrationError } from "@pageUtils/message-alert";

export const validateFileImage = ({ fileUpload }) => {
  const allowedExtensions = ["jpeg", "jpg", "png"];

  // destructuring file name and size from file object
  const { name: fileName, size: fileSize } = fileUpload;

  /*
   * if filename is apple.png, we split the string to get ["apple","png"]
   * then apply the pop() method to return the file extension
   *
   */
  const fileExtension = fileName.split(".").pop();

  /*
      check if the extension of the uploaded file is included
      in our array of allowed file extensions
    */
  if (!allowedExtensions.includes(fileExtension)) {
    ConfirmRegistrationError({
      callbackFunction: null,
      title: "ไม่สามารถทำรายการได้",
      text: "กรุณาเลือกไฟล์รูปภาพเท่านั้น (.png, .jpg และ .jpeg)",
    });
    return true;
  }
  // else if (fileSize > sizeLimit) {
  //   ConfirmRegistrationError({
  //     callbackFunction: null,
  //     title: "ไม่สามารถทำรายการได้",
  //     text: "กรุณาเลือกไฟล์รูปภาพเท่านั้น (.png, .jpg และ .jpeg)",
  //   });
  //   return true;
  // }
  return false;
};
